import { filterNonNull } from "@zennya/web-component-library/src/components/SegmentIO";
import axios from "axios";
import { sessionTokenState } from "pages/CustomerBookingCreate/state";
import { anonCalculate } from "./anon.service";

const API_URL = process.env.REACT_APP_WEB_ADMIN_URL;


const calculateFromBooking = async ({
  booking,
  packages,
  services,
  clientId,
  sessionToken,
}) => {
  try {
    const catType = booking?.serviceCategory?.featured_service?.type_id || booking?.serviceCategory?.type?.id

    if (!catType || !booking?.location?.latitude || !booking?.location?.longitude) {
      return {
        count: 0,
        total: 0
      }
    }
    if (packages?.length === 0 && services?.length === 0) {
      return {
        count: 0,
        total: 0
      }
    }
    if (clientId) {
      const params = {
        extended_packages: packages?.map((p) => p.id),
        extended_package_items: services?.map((s) => s.id),
        clientId,
        packages: null,
        latitude: booking?.location?.latitude,
        longitude: booking?.location?.longitude,
        serviceCategoryTypeId: catType,
        "white_label_customer": booking?.white_label_customer?.id,
      }
      return await calculate(params)
    } else {
      const params = {
        extended_packages: packages?.map((p) => p.id),
        extended_package_items: services?.map((s) => s.id),
        session_token: sessionToken,
        packages: null,
        latitude: booking?.location?.latitude,
        longitude: booking?.location?.longitude,
        serviceCategoryTypeId: catType
      }
      return await anonCalculate(params)
    }
  } catch (error) {
    console.log('createBooking.services.js (39)', error)
  }
}

const calculate = async ({
  clientId,
  latitude,
  longitude,
  packages,
  extended_packages,
  extended_package_items,
  serviceCategoryTypeId,
  ...rest
}) => {
  const params = filterNonNull({
    ...rest,
    lat: latitude,
    lng: longitude,
    extended_package_items,
    packages,
    extended_packages,
    client_type: 'web',
    type: serviceCategoryTypeId,
    should_check_for_payment: true,
    should_check_for_medical_id: false,
    should_check_for_promo_usage: false,

  })
  return (await axios.post(`${API_URL}/api/1/clients/${clientId}/bookings/calculate`, params))?.data;
};


export { calculateFromBooking, calculate };
